import { LockOpen } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgLockOpen = mkIcon(LockOpen);